module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff?e74681c1a4b2fd54332bcb113f74ad52";